/**
 * i18n setup for PUREFRAGANCE.
 * - Spanish (default) + English
 * - Language stored in localStorage under "pf_lang"
 * - Namespaces: common (UI strings), families (perfume families), notes (olfactive notes)
 */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";
import esFamilies from "./locales/families.es.json";
import enFamilies from "./locales/families.en.json";
import esNotes from "./locales/notes.es.json";
import enNotes from "./locales/notes.en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: es, families: esFamilies, notes: esNotes },
      en: { common: en, families: enFamilies, notes: enNotes },
    },
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    ns: ["common", "families", "notes"],
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "pf_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

/** Translate a perfume family key (floral, amaderado…) to the current language. */
export const tFamily = (key) => i18n.t(key, { ns: "families", defaultValue: key });

/** Translate a comma-list or array of olfactive notes to the current language.
 *  Falls back to the original note when no mapping exists. */
export const tNotes = (notes) => {
  const arr = Array.isArray(notes) ? notes : String(notes || "").split(",").map((s) => s.trim()).filter(Boolean);
  return arr
    .map((n) => i18n.t(n.toLowerCase(), { ns: "notes", defaultValue: n }))
    .join(", ");
};

export default i18n;
